import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: "root"
})
export class ConfigService {

  configUrl = '/API/GetSettings/';

getConfig() {
  return this.http.get(this.configUrl);
}

  constructor(private http: HttpClient) {

  }
}

export interface Config {
  debugView: string;
  signalRUrl: string;
  webSocketUrl: string;
  singalSizeAmount:number
}
